import {ReactElement} from "react";
import {RendererProps} from "../RendererProps";
import {ensureNotObject, formatYearAndVersionType} from "../common";
import * as common from "../styles/common.module.scss";

const VALUE_PROPS = [
    "month0",
    "month1",
    "month2",
    "month3",
    "month4",
    "month5",
    "month6",
    "month7",
    "month8",
    "month9",
    "month10",
    "month11"
];

export function RenderSetOperationalMonthlyAverageCustomIncreases(props: RendererProps): ReactElement {
    const year = props.variables["year"];
    const versionType = props.variables["versionType"];

    const values: ReactElement[] = [];
    for(let i = 0; i < VALUE_PROPS.length; i++) {
        const prop = VALUE_PROPS[i];
        if(!prop) {
            continue;
        }

        const value = props.variables[prop];
        if(value !== null && value !== undefined) {
            values.push(<li key={prop}>Month {i + 1}: {ensureNotObject(value)}</li>);
        }
    }

    return <div>
        <div className={common.textHeader}>{formatYearAndVersionType(year, versionType)}</div>
        <ul>{values}</ul>
    </div>;
}